import { ZoneGateway } from '@scenario/gateways/zoneGateway';
import { ScenarioGateway } from '@scenario/gateways/scenario.gateway';
import { SourceGateway } from '@scenario/gateways/source.gateway';
import { BasecaseGateway } from '@scenario/gateways/basecase.gateway';
import { SubtypeGateway } from '@scenario/gateways/subtype.gateway';
import { ExportGateway } from '@scenario/gateways/export.gateway';
import { MarketAreaGateway } from '@scenario/gateways/market-area.gateway';
import { RegionManagerGateway } from '@scenario/gateways/region-manager.gateway';
import { UnitRatesGateway } from '@scenario/gateways/unit-rates.gateway';
import { UserPreferencesGateway } from '@scenario/gateways/user-preferences.gateway';
import { UserRolesGateway } from '@scenario/gateways/user-roles.gateway';
import { SubscriptionGateway } from '@scenario/gateways/subscription.gateway';
import { WeatherYearGateway } from '@scenario/gateways/weather-year.gateway';
import { IdProvider } from '@scenario/providers/id.provider';
import { FilteredReferentialsGateway } from '@scenario/gateways/filtered-referentials.gateway';
import { TechnologyGateway } from '@price-card/gateways/technology.gateway';
import { CommercialOperationDateGateway } from '@price-card/gateways/commercial-operation-date.gateway';
import { PriceCardDataGateway } from '@price-card/gateways/price-card-data.gateway';
import { PriceCardFileGateway } from '@price-card/gateways/price-card-file.gateway';
import { PriceCardSubscriptionGateway } from '@price-card/gateways/subscription.gateway';
import { ReleaseDocumentationGateway } from '@scenario/gateways/release-documentation.gateway';
import { PmoGateway } from '@scenario/gateways/pmo.gateway';
import { AnalystGateway } from '@scenario/gateways/analyst.gateway';
import { PsfUserGateway } from '@scenario/gateways/psf-user.gateway';
import { HourlyDataRequestGateway } from '@scenario/gateways/hourly-data-request.gateway';
import { HourlyRequestFilteredReferentialsGateway } from '@scenario/gateways/hourly-request-filtered-referentials.gateway';

export let dependencies: Dependencies;
export interface Dependencies {
  scenarioGateway: ScenarioGateway;
  regionGateway: ZoneGateway;
  sourceGateway: SourceGateway;
  basecaseGateway: BasecaseGateway;
  subtypeGateway: SubtypeGateway;
  exportGateway: ExportGateway;
  marketAreaGateway: MarketAreaGateway;
  regionManagerGateway: RegionManagerGateway;
  unitRatesGateway: UnitRatesGateway;
  userPreferencesGateway: UserPreferencesGateway;
  userRolesGateway: UserRolesGateway;
  subscriptionGateway: SubscriptionGateway;
  weatherYearGateway: WeatherYearGateway;
  filteredReferentialsIdsGateway: FilteredReferentialsGateway;
  idProvider: IdProvider;
  technologyGateway: TechnologyGateway;
  priceZoneGateway: ZoneGateway;
  commercialOperationDateGateway: CommercialOperationDateGateway;
  priceCardDataGateway: PriceCardDataGateway;
  priceCardFileGateway: PriceCardFileGateway;
  priceCardSubscriptionGateway: PriceCardSubscriptionGateway;
  releaseDocumentationGateway: ReleaseDocumentationGateway;
  pmoGateway: PmoGateway;
  analystGateway: AnalystGateway;
  psfUserGateway: PsfUserGateway;
  hourlyDataRequestGateway: HourlyDataRequestGateway;
  hourlyRequestFilteredReferentialsIdsGateway: HourlyRequestFilteredReferentialsGateway;
}
